import { useReducer as t } from "react";
const c = () => {
  const [, e] = t((r) => r + 1, 0);
  return e;
};
export {
  c as useForceUpdate
};
//# sourceMappingURL=useForceUpdate.js.map
